import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";
import { BaseUrl } from "../../Helper/BaseUrl";

// Get Table Data
export const ServicesTableDataAPI = createAsyncThunk("ServicesTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_SW_WorkTypeID,
        M_SW_WorkPeriodID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        handleServicesExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_SW_T_SW_RMServices_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_SW_WorkTypeID=${M_SW_WorkTypeID ? M_SW_WorkTypeID : '0'}&M_SW_WorkPeriodID=${M_SW_WorkPeriodID ? M_SW_WorkPeriodID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleServicesExport && handleServicesExport()
                return result.data
            } else {
                return result
            }
        })
})

const ServicesTableDataSlice = createSlice({
    name: "ServicesTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ServicesTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ServicesTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(ServicesTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ServicesTableDataReducer = ServicesTableDataSlice.reducer


export const ServicesExportTableDataAPI = createAsyncThunk("ServicesExportTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_SW_WorkTypeID,
        M_SW_WorkPeriodID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        setPDF
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_SW_T_SW_RMServices_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_SW_WorkTypeID=${M_SW_WorkTypeID ? M_SW_WorkTypeID : '0'}&M_SW_WorkPeriodID=${M_SW_WorkPeriodID ? M_SW_WorkPeriodID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if(result.url && result.url !=''){
                setPDF(result.url)
            }
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ServicesExportTableDataSlice = createSlice({
    name: "ServicesTableData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ServicesExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(ServicesExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(ServicesExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ServicesExportTableDataReducer = ServicesExportTableDataSlice.reducer

// -----------------Delete API ---------------

export const ServicesMasterDeleteAPI = createAsyncThunk("ServicesMasterDelete", async ({ data }) => {
    const {
        T_SW_RMServicesID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("T_SW_RMServicesID", T_SW_RMServicesID);
    formdata.append("M_UserID", M_UserID);
    
    var requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    
    fetch(`${BaseUrl}/APKDashboard/WEB_SW_T_SW_RMServices_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const ServicesMasterDeleteSlice = createSlice({
    name: "ServicesMasterDelete",
    initialState: {
        isDeleteLoading: false,
        ServicesData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ServicesMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(ServicesMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.ServicesData = action.payload;

        });
        builder.addCase(ServicesMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.ServicesData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const ServicesMasterDeleteReducer = ServicesMasterDeleteSlice.reducer